'use client';

import { useMutation } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { Binoban } from '../helpers/binoban';

export const useLogout = () => {
  const { signoutRedirect } = useAuth();

  return useMutation(async () => {
    Binoban.reset();
    return await signoutRedirect();
  });
};
